exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".emoji{vertical-align:top}.messageinput{width:calc(100% - 110px)!important;float:left!important;height:100%!important}.emojionearea-picker{right:auto!important;left:0}.emojionearea-editor{min-height:38px!important}.chat-textbox{margin-bottom:10px;position:relative}.emojionearealocked img{width:20px;height:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-949ed830","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/discuss/discuss-singlethread.vue
// module id = 1171
// module chunks = 0